'use client';

import React, { useCallback } from 'react';
import { useRealtimeManagerChannels } from '@/lib/hooks/useRealtimeManagerChannels';
import RealtimeConflictAlerts from '@/components/ui/RealtimeConflictAlerts';

/**
 * ManagerRealtimeLayer
 *
 * Client component that:
 * - Subscribes to duty_assignments + crew_members postgres changes
 * - Subscribes to manager_conflict_alerts broadcast channel
 * - Renders the live ConflictAlerts panel when alerts are present
 *
 * Drop this anywhere in a manager screen layout.
 */
export default function ManagerRealtimeLayer() {
  const { conflictAlerts, clearConflict, clearAllConflicts } = useRealtimeManagerChannels({
    enabled: true,
  });

  if (conflictAlerts?.length === 0) return null;

  return (
    <RealtimeConflictAlerts
      alerts={conflictAlerts}
      onClear={clearConflict}
      onClearAll={clearAllConflicts}
    />
  );
}
